import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { fetchJson } from '@zapier/toolbox-browser-fetch';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { useNotify } from 'app/developer-v3/hooks';

import { getQueryKey } from './useQueryActiveDeployKeys';

const MUTATION_KEY = 'mutate-create-deploy-key';
const queryKey = getQueryKey();

function useMutationCreateDeployKeys(
  options?: UseMutationOptions<Record<string, any>, Error, void>
) {
  const notify = useNotify();

  const queryClient = useQueryClient();

  const mutationKey = MUTATION_KEY;
  const url = new URL('/api/platform/cli/keys', ZAPIER_APP_BASE_URL);

  const mutation = useMutation({
    mutationKey,
    mutationFn: async () =>
      fetchJson(url.href, { body: JSON.stringify({}), method: 'POST' }),
    onError: (error, _variables) => notify.failure(error.message, mutationKey),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
      notify.success('Deploy key created.');
    },
    ...options,
  });

  return { ...mutation, mutate: mutation.mutateAsync, mutationKey };
}

export default useMutationCreateDeployKeys;
